import { render, staticRenderFns } from "./adminOrderInfo.vue?vue&type=template&id=341316f6&scoped=true&"
import script from "./adminOrderInfo.js?vue&type=script&lang=js&"
export * from "./adminOrderInfo.js?vue&type=script&lang=js&"
import style0 from "./adminOrderInfo.css?vue&type=style&index=0&id=341316f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341316f6",
  null
  
)

export default component.exports